import { createSelector } from '@reduxjs/toolkit';

import { ProductionComponentInstanceStatus } from '@paragon/contract-library';

import { getBundlesByProductionGroupGuid } from './bundles';
import { getProjectLayoutModels } from './getProjectLayoutModels';
import { getProductionGroupsByProjectGuid, getStatusesByProductionGroupGuid } from './productionGroups';

const activeStatuses: readonly ProductionComponentInstanceStatus[] = [
  'Unscheduled',
  'Scheduled',
  'StartedAssembly',
  'FinishedAssembly',
  'StoredOnYard',
  'Shipped',
];

/**
 * Active means having a status other than delivered and includes production groups where bundling has not yet occurred.
 */
export const getProjectsWithActiveProductionGroups = createSelector(
  getProjectLayoutModels,
  getProductionGroupsByProjectGuid,
  getStatusesByProductionGroupGuid,
  getBundlesByProductionGroupGuid,

  (projectLayoutModels, productionGroupsByProjectGuid, statusesByProductionGroupGuid, bundlesByProductionGroupGuid) =>
    projectLayoutModels.filter((projectLayoutModel) =>
      productionGroupsByProjectGuid[projectLayoutModel.guid]?.some(
        (productionGroup) =>
          activeStatuses.some((activeStatus) =>
            statusesByProductionGroupGuid[productionGroup.guid].includes(activeStatus),
          ) || bundlesByProductionGroupGuid[productionGroup.guid].length === 0,
      ),
    ),
);
